import Aryans from "../assets/logos/Aryans.png"
import Mughals from "../assets/logos/Mughals.png"
import Rajputs from "../assets/logos/Rajputs.png"
import Spartans from "../assets/logos/Spartans.png"
import Vikings from "../assets/logos/Vikings.png"

export default function Logos() {
	return (
		<div className="flex flex-wrap justify-center m-8 lg:my-16">
			<img className="w-1/3 lg:w-1/6 select-none transition hover:scale-105" src={Aryans} alt="Aryans"/>
			<img className="w-1/3 lg:w-1/6 select-none transition hover:scale-105" src={Mughals} alt="Mughals"/>
			<img className="w-1/3 lg:w-1/6 select-none transition hover:scale-105" src={Rajputs} alt="Rajputs"/>
			<img className="w-1/3 lg:w-1/6 select-none transition hover:scale-105" src={Spartans} alt="Spartans"/>
			<img className="w-1/3 lg:w-1/6 select-none transition hover:scale-105" src={Vikings} alt="Vikings"/>
		</div>
	);
}
